'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:ProspectShowCtrl
 * @description
 * # ProspectShowCtrl
 * Controller of the thothAppApp
 */
angular.module('thothApp.controllers')
  .controller('ProspectShowCtrl', [
    '$scope', '$rootScope', '$state', '$stateParams', 'Prospect', 'Client', 'GoogleApi', 'toaster', function ($scope, $rootScope, $state, $stateParams, Prospect, Client, GoogleApi, toaster) {
      $rootScope.rootPath = {
        url: '',
        id: '',
      };
      var currentProspectName;
      var currentDriveId;
      $scope.clientHash = {}

      Prospect.find($stateParams.prospectId).then(function(response) {
        $rootScope.isPicked = true;
        $scope.prospectHash = { 'prospect': response.data.prospect };
        currentProspectName = $scope.prospectHash.prospect.name;
        currentDriveId = $scope.prospectHash.prospect.drive_root_id;
      }, function(error) {
        Prospect.error(error);
      });

      $scope.convertToClient = function() {
        if($rootScope.rootPath.id != '' && $rootScope.rootPath.url != '') {
          if(window.confirm(`¿Estas seguro que deseas convertir el prospecto ${$scope.prospectHash.prospect.name} a cliente?`)){
            Client.next_client_code().then((response) => {
              $scope.clientHash = {
                'client': {
                  'name': $scope.prospectHash.prospect.name,
                  'client_code': response.data.client_code,
                  'sav7_id': '',
                  'email': '',
                  'rfc': '',
                  'complete_name': '',
                  'was_prospect': true,
                  'converted_to_prospect_by': $rootScope.myUser.id

                }
              }
              GoogleApi.moveProspectFoldersToClientFolders($scope.prospectHash.prospect.drive_root_id, $scope.prospectHash.prospect.name, $rootScope.rootPath.id).then(function(response) {
                //Succesfully updated folder name.
                $scope.clientHash.client.drive_root_id = response.client_root_id;
                $scope.clientHash.client.drive_root_url = response.client_root_url;
                Client.save($scope.clientHash).then((response) => {
                  $scope.clientHash = {
                    'client': {
                      'name': '',
                      'client_code': '0',
                      'sav7_id': '',
                      'email': '',
                      'rfc': '',
                      'complete_name': '',
                      'was_prospect': false,
                      'converted_to_prospect_by': null
                    }
                  }
                  Prospect.delete($scope.prospectHash.prospect.id).then(function(response) {
                    toaster.pop('success', 'Prospecto Actualizado', 'Se convirtio el prospecto a cliente correctamente');
                  }, function(error) {
                    Prospect.error(error);
                  });
                  $state.go('app.clients.show', {clientId: response.data.client.id});
                }).catch((error) => {
                  //Error while creating Client
                  Client.error(error);
                });
              }, function(error) {
                console.log(error);
                GoogleApi.error(error);
              });
            })
          }
          $scope.clientHash = {
            'client': {
              'name': '',
              'client_code': '0',
              'sav7_id': '',
              'email': '',
              'rfc': '',
              'complete_name': '',
              'was_prospect': false,
              'converted_to_prospect_by': null
            }
          }
        } else {
          toaster.pop('error', 'Error', 'No se ha seleccionado una carpeta');
        }
      }

      $scope.selectFolder = function() {
        GoogleApi.pickerApiLoad(GoogleApi.getClientBaseFolderId(), 'folder');
      };
  }]);
